import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../../../features/events/redux/actions';
import history from '../../../../common/history';
import * as externalApiActions from '../../../../features/external-api/redux/actions';
import { getFilteredArray, processSessionKeyMapping } from '../sendDataToExternalApi/util';
import voca from 'voca';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { createActionSettingsSchema, getFieldInfoByName } from '../collection/Util';
import BrowserStorageOptions from '../BrowserStorageOptions';

class ExternalSourceActionForm extends Component {
  state = {
    params: [],
    formDataParams: [],
    showAdvanceForPreviousActionFormData: false,
    showAdvanceForPreviousActionResponse: false,
    showBSLOption: false,
  };

  componentDidMount() {
    const { projectId, eventAction, version } = this.props;
    this.props.externalApiActions.loadExternalApis({ projectId, version });
    const dbParams = eventAction.parameters.find((param) => {
      return param.name === 'overriddenSessionKeyRules';
    });
    const dbFormParams = eventAction.parameters.find((param) => {
      return param.name === 'overriddenSessionFormDataKeyRules';
    });

    this.setState({
      ...this.state,
      params:
        dbParams && !voca.isEmpty(dbParams.value)
          ? dbParams.value
          : [{ id: 1, originalSessionKey: '', overriddenSessionKey: '' }],
      formDataParams:
        dbFormParams && !voca.isEmpty(dbFormParams.value)
          ? dbFormParams.value
          : [{ id: 1, originalSessionKey: '', overriddenSessionKey: '' }],
    });
  }

  createNewParamRow = (rowObj) => {
    const params = processSessionKeyMapping(this.state.params, rowObj);
    this.setState({ params });
  };

  createNewFormDataParamRow = (rowObj) => {
    const formDataParams = processSessionKeyMapping(this.state.formDataParams, rowObj);
    this.setState({ formDataParams });
  };

  handleSubmit = (values) => {
    const { actionData, eventAction, actions, projectId, version, selectedEvent } = this.props;
    const { params, formDataParams } = this.state;

    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      if (action) {
        parameters.push({ name: value, value: values[value], type: action.type });
      }
    });

    parameters.push({
      name: 'overriddenSessionKeyRules',
      value: getFilteredArray(params),
      type: 'array',
    });
    parameters.push({
      name: 'overriddenSessionFormDataKeyRules',
      value: getFilteredArray(formDataParams),
      type: 'array',
    });

    let actionFormData = eventAction;
    actionFormData.parameters = parameters;

    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  externalApiOptions = () => {
    let options = [];
    const { externalapi, externalApiType } = this.props;
    const { externalApis } = externalapi ? externalapi : '';
    if (externalApis.length > 0) {
      if (externalApiType) {
        options = options.concat(
          externalApis
            .filter((externalApi) => externalApi.externalApiType === externalApiType)
            .map((externalAPI) => {
              return { value: externalAPI.uuid, label: externalAPI.externalApiName };
            }),
        );
      } else {
        options = options.concat(
          externalApis.map((externalAPI) => {
            return { value: externalAPI.uuid, label: externalAPI.externalApiName };
          }),
        );
      }
    }
    return options;
  };

  closeAllOpenPopup = () => {
    const { projectId, actions, version } = this.props;
    actions.closeActionFormModal();
    history.push(`/2.0/externalapi/${version}/v/${projectId}/create`);
  };

  advanceOptionHandler = (event, name) => {
    if (name === 'passPreviousActionFormData') {
      this.setState({
        showAdvanceForPreviousActionFormData: !this.state.showAdvanceForPreviousActionFormData,
      });
    }
    if (name === 'passPreviousActionResponse') {
      this.setState({
        showAdvanceForPreviousActionResponse: !this.state.showAdvanceForPreviousActionResponse,
      });
    }
  };

  validateFormDataSessionKey = (value) => {
    console.log(
      '🚀 ExternalSourceActionForm ~ CollectionActionForm validateFormDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  validateResponseDataSessionKey = (value) => {
    console.log(
      '🚀 ExternalSourceActionForm ~ CollectionActionForm validateResponseDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  bslOptionHandler = () => {
    this.setState({
      showBSLOption: !this.state.showBSLOption,
    });
  };

  render() {
    const { eventAction, actionData, externalApiType } = this.props;
    const { showBSLOption } = this.state;
    return (
      <Formik
        enableReinitialize={true}
        initialValues={createActionSettingsSchema(actionData, eventAction)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="External API"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('externalAPI')}
                  >
                    <CustomSelect
                      name={'webhookId'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.externalApiOptions()}
                      value={values['webhookId']}
                      onChangeValue={this.handleChange}
                      placeholder={`${
                        externalApiType ? voca.titleCase(externalApiType) + ' ' : ''
                      }External API`}
                    />
                    <ErrorMessage name={'webhookId'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Success Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter Success message (optional) you want to display on successful execution.`}
                  >
                    <Field
                      type="text"
                      name="successMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Success Message (Optional)"
                    />
                    <ErrorMessage name="successMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Error Message"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter Error message (optional) you want to display on encountering an error.`}
                  >
                    <Field
                      type="text"
                      name="errorMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="Error Message (Optional)"
                    />
                    <ErrorMessage name="errorMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                  </FormFieldWithLabel>
                </div>
                <div className="form-group">
                  <button
                    onClick={(e) => this.bslOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-5 p-1"
                    title="Show Browser Storage Options"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                  </button>
                </div>
                {showBSLOption && (
                  <BrowserStorageOptions
                    values={values}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    validateFormDataSessionKey={this.validateFormDataSessionKey}
                    validateResponseDataSessionKey={this.validateResponseDataSessionKey}
                    sendPreviousActionResponseItemId={false}
                  />
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={this.props.hideModal}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button type="submit" className="btn btn-theme-submit btn-sm">
                  <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
    externalapi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    externalApiActions: bindActionCreators({ ...externalApiActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalSourceActionForm);
